<template>
  <div class="responsive-image" :style="{'background-image': currentImage}"></div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "responsive-image",
  props: {
    image: { type: String, default: "" },
    image2: { type: String, default: "" }
  },
  computed: mapState({
    smallScreen: state => state.globals.smallScreen,
    currentImage: function(state) {
      return `url(${!state.globals.smallScreen ? this.image : this.image2})`;
    }
  }),
  methods: {}
};
</script>

<style scoped lang="scss">
.responsive-image {
  width: 100%;
  height: 100%;
  background: center / cover no-repeat;

  @media screen and (min-width: 765px) {
    padding-bottom: 90% * 11 / 16;
    height: auto;
  }
}
</style>